import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import periodoService from '../../services/periodo.service';
import SePode from '../../components/SePode';   // r90

// ════════════════════════════════════════════════════════════════════════════
// PeriodoFecharModal — confirma fechamento A→F + mostra pendências
// ════════════════════════════════════════════════════════════════════════════

const COR = {
  azul:    '#003399', azulBg:  '#eff6ff',
  borda:   '#e8eaed', texto:   '#1a1a2e', muted: '#888',
  branco:  '#fff',    cinzaBg: '#fafafa',
  verde:   '#10b981',
  vermelho:'#dc2626', vermBg:  '#fff0f0',
  amarelo: '#d97706', amlBg:   '#fffbeb',
};

function PeriodoFecharModal({ periodo, onFechar }) {
  const { usuario } = useAuth();
  const [check, setCheck] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await periodoService.podeFechar(periodo.id);
        setCheck(r);
      } catch (err) {
        setCheck({ pode: false, motivo: err.message });
      } finally {
        setCarregando(false);
      }
    })();
  }, [periodo.id]);

  const confirmar = async () => {
    try {
      setSalvando(true);
      await periodoService.fechar(periodo.id, usuario.id);
      onFechar(true);
    } catch (err) {
      alert(err.response?.data?.mensagem || err.message);
      setSalvando(false);
    }
  };

  const mmaaaa = `${String(periodo.mes).padStart(2, '0')}/${periodo.ano}`;

  return (
    <div style={{
      position: 'fixed', inset: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: '20px',
    }} onClick={(e) => e.target === e.currentTarget && onFechar(false)}>
      <div style={{
        backgroundColor: COR.branco, borderRadius: '8px',
        width: '560px', maxWidth: '100%', maxHeight: '85vh',
        display: 'flex', flexDirection: 'column',
        fontFamily: "'Manrope', sans-serif",
      }}>
        <div style={{
          padding: '14px 18px', borderBottom: `1px solid ${COR.borda}`,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700' }}>
            Fechar Período {mmaaaa}
          </h2>
          <button onClick={() => onFechar(false)}
            style={{
              width: '28px', height: '28px', border: 'none',
              backgroundColor: 'transparent', fontSize: '20px',
              color: COR.muted, cursor: 'pointer',
            }}>×</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 18px' }}>
          {carregando ? (
            <div style={{ textAlign: 'center', color: COR.muted }}>Verificando...</div>
          ) : check.pode ? (
            <div>
              <p style={{ fontSize: '13px', color: COR.texto, marginTop: 0 }}>
                Tudo certo pra fechar este período.
              </p>
              <div style={{
                padding: '12px 14px', backgroundColor: COR.amlBg,
                border: `1px solid ${COR.amarelo}33`, borderRadius: '6px',
                fontSize: '12px', color: COR.texto,
              }}>
                ⚠ Ao fechar, <strong>todos os lançamentos</strong> deste período
                terão a situação alterada para <strong>"Fechada"</strong> e não
                poderão mais ser editados ou excluídos.
              </div>
            </div>
          ) : (
            <div>
              <div style={{
                padding: '12px 14px', backgroundColor: COR.vermBg,
                border: `1px solid ${COR.vermelho}33`, borderRadius: '6px',
                fontSize: '13px', color: COR.vermelho, fontWeight: '600',
                marginBottom: '14px',
              }}>
                Não é possível fechar: {check.motivo}
              </div>
              {check.pendencias && check.pendencias.length > 0 && (
                <div>
                  <div style={{
                    fontSize: '11px', fontWeight: '700', color: COR.muted,
                    textTransform: 'uppercase', letterSpacing: '0.5px',
                    marginBottom: '8px',
                  }}>Pendências encontradas</div>
                  <div style={{
                    border: `1px solid ${COR.borda}`, borderRadius: '6px',
                    maxHeight: '300px', overflowY: 'auto',
                  }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                      <thead>
                        <tr style={{ backgroundColor: COR.cinzaBg }}>
                          <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '11px',
                                       color: COR.muted, textTransform: 'uppercase' }}>Analista</th>
                          <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '11px',
                                       color: COR.muted, textTransform: 'uppercase' }}>Data</th>
                          <th style={{ padding: '8px 12px', textAlign: 'right', fontSize: '11px',
                                       color: COR.muted, textTransform: 'uppercase' }}>Qtd</th>
                        </tr>
                      </thead>
                      <tbody>
                        {check.pendencias.map((p, i) => (
                          <tr key={i} style={{ borderTop: `1px solid ${COR.borda}` }}>
                            <td style={{ padding: '6px 12px' }}>{p.analista}</td>
                            <td style={{ padding: '6px 12px' }}>
                              {new Date(p.data).toLocaleDateString('pt-BR')}
                            </td>
                            <td style={{ padding: '6px 12px', textAlign: 'right', fontWeight: '600' }}>
                              {p.qtd}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ marginTop: '10px', fontSize: '12px', color: COR.muted }}>
                    Os lançamentos acima estão como <strong>Planejada</strong>.
                    Execute-os ou exclua-os antes de fechar o período.
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div style={{
          padding: '12px 18px', borderTop: `1px solid ${COR.borda}`,
          display: 'flex', justifyContent: 'flex-end', gap: '8px',
        }}>
          <button onClick={() => onFechar(false)}
            style={{
              padding: '8px 16px', fontSize: '12px', fontWeight: '600',
              border: `1px solid ${COR.borda}`, borderRadius: '5px',
              backgroundColor: COR.branco, color: COR.muted, cursor: 'pointer',
            }}>{check?.pode ? 'Cancelar' : 'Fechar'}</button>
          {check?.pode && (
            <SePode rotina="periodos" acao="fechar">
            <button onClick={confirmar} disabled={salvando}
              style={{
                padding: '8px 20px', fontSize: '12px', fontWeight: '700',
                border: 'none', borderRadius: '5px',
                backgroundColor: COR.azul, color: COR.branco,
                cursor: salvando ? 'default' : 'pointer',
                opacity: salvando ? 0.6 : 1,
              }}>{salvando ? 'Fechando...' : 'Confirmar fechamento'}</button>
            </SePode>
          )}
        </div>
      </div>
    </div>
  );
}

export default PeriodoFecharModal;
